import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Department Module Service Stores
 */
export const departmentStores: ServiceStoreConfig[] = [
  {
    name: "departments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.departmentsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalDepartments = entities.length;

          return [
            {
              title: "Total Departments",
              value: () => totalDepartments.toString(),
              valueColor: "primary.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
